import { KnBrAddRequestEntry } from './../../../models/kn-br-order.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { OCC_USER_ID_CURRENT, RoutingService, TranslatePipe } from '@spartacus/core';
import { ICON_TYPE, LaunchDialogService, IconComponent } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CustomerData } from 'src/app/models/customer.model';
import { KnBrQuoteReferenceService } from 'src/app/store/kn-br-quote-reference/kn-br-quote-reference.service';

import { KnBrCartContextService } from '../../../store/kn-br-cart-context/kn-br-cart-context.service';
import { KnBrCustomerContextService } from '../../../store/kn-br-customer-context/kn-br-customer-context.service';
import { KnBrDraftOrdersService } from '../../../store/kn-br-draft-orders/kn-br-draft-orders.service';
import { DraftSearchForm } from './../../../models/draft-order.model';
import * as _ from 'lodash';
import { MultiCartService } from '@spartacus/cart/base/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent, NgOptionTemplateDirective, NgLabelTemplateDirective } from '@ng-select/ng-select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { RemoveLeadingZerosPipe } from '../../../shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';

@Component({
    selector: 'kn-br-select-cart',
    templateUrl: './kn-br-select-cart.component.html',
    styleUrls: ['./kn-br-select-cart.component.scss'],
    imports: [IconComponent, NgSelectComponent, ReactiveFormsModule, FormsModule, NgOptionTemplateDirective, NgLabelTemplateDirective, AsyncPipe, TranslatePipe, RemoveLeadingZerosPipe]
})
export class KnBrSelectCartComponent implements OnInit, OnDestroy {
  productCode: string;
  quantity: number;
  iconTypes = ICON_TYPE;
  cartCode: string;
  cartList$: Observable<any> = this.knBrDraftOrderListService.list$;
  customerContextData$: Observable<CustomerData> = this.knBrCustomerContextService.get$;
  subscription: Subscription;
  productList: KnBrAddRequestEntry[];
  customerNumber;
  constructor(
    protected modalService: NgbModal,
    protected routingService: RoutingService,
    protected knBrDraftOrderListService: KnBrDraftOrdersService,
    protected multiCartService: MultiCartService,
    protected knBrCartContextService: KnBrCartContextService,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected knBrQuoteReferenceService: KnBrQuoteReferenceService
  ) {
    this.subscription = this.customerContextData$.subscribe((value) => {
      this.knBrDraftOrderListService.reset();
      if (value.customerNumber) {
        this.customerNumber = value.customerNumber;
        this.knBrDraftOrderListService.search({ accountNumber: value.customerNumber } as DraftSearchForm);
      }
    });
  }
  ngOnInit(): void {}
  goToCreateNewCart() {
    if (this.knBrQuoteReferenceService.pdpQuoteRef) {
      this.knBrCartContextService.pdpQuoteRef = _.cloneDeep(this.knBrQuoteReferenceService.pdpQuoteRef);
    }

    this.multiCartService.createCart({
      userId: OCC_USER_ID_CURRENT,
      extraData: { active: true },
    }).subscribe((cart: any) => {
      this.knBrCartContextService.set(cart.code);

      if (this.productList && this.productList.length > 0) {
        this.multiCartService.addEntries(
          OCC_USER_ID_CURRENT,
          cart.code,
          this.productList.map((entry) => ({
            productCode: entry.productCode,
            quantity: entry.quantity || 1,
          }))
        );
      } else {
        this.routingService.go({ cxRoute: 'cartDetails', params: { code: cart.code } }, { queryParams: { p: this.productCode, q: this.quantity } });
      }
    }, () => {
      this.routingService.go({ cxRoute: 'createCart' }, { queryParams: { p: this.productCode, q: this.quantity } });
    });

    this.dismissModal();
  }
  saveCart() {
    this.knBrCartContextService.set(this.cartCode);
    if (this.productList && this.productList.length > 0) {
      this.multiCartService.addEntries(
        OCC_USER_ID_CURRENT,
        this.cartCode,
        this.productList.map((entry) => ({
          productCode: entry.productCode,
          quantity: entry.quantity || 1,
        }))
      );
      this.dismissModal();
    } else {
      this.multiCartService.addEntry(OCC_USER_ID_CURRENT, this.cartCode, this.productCode, this.quantity);
      this.dismissModal();
    }
  }
  dismissModal(reason?: any): void {
    this.modalService.dismissAll(reason);
  }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
